<template>
  <v-card
    loader-height="8"
    :loading="admin.subsystemsLoading"
    :disabled="admin.subsystemsLoading"
    min-width="600"
    :min-height="minCardHeight"
    class=""
  >
    <v-toolbar color="blue darken-2" class="text-h4 text-uppercase" dark>
      {{ tabName }}
      <v-spacer></v-spacer>

      <v-icon>{{ app.subSystemIcon }}</v-icon>
    </v-toolbar>
    <v-card-text>
      <v-overlay :opacity="0.9" absolute :value="showSaveOverlay">
        <v-btn color="success"> Subsystem saved </v-btn>
      </v-overlay>
      <v-form v-model="valid">
        <v-text-field
          v-model="id"
          label="System Definition Id"
          disabled
          readonly
        >
        </v-text-field>
        <v-text-field
          v-model="name"
          :rules="validation.length50"
          label="SubSystem Name"
          required
          autofocus
        ></v-text-field>
        <v-text-field
          v-model="description"
          :rules="validation.length250"
          label="Subsystem Description"
          required
        ></v-text-field>
        <v-text-field
          v-model="subsystemType"
          :rules="validation.length25"
          label="Subsystem Type"
          required
        ></v-text-field>
        <v-select
          v-model="userType"
          :items="admin.userTypeList"
          chips
          label="User Type"
          multiple
          item-text="label"
          item-value="value"
        >
          <template v-slot:selection="{ item, index }">
            <v-chip :key="index" color="#555" large dark>
              {{ item.value }}
            </v-chip>
          </template>
        </v-select>
        <v-checkbox
          color="blue darken-2"
          v-model="published"
          label="Published"
        ></v-checkbox>
      </v-form>
    </v-card-text>
    <v-card-actions class="mt-16">
      <v-spacer />
      <v-btn
        dark
        color="blue darken-2"
        @click="saveSubsystem"
        :disabled="!valid"
        >save</v-btn
      >
      <v-btn color="gray" @click="closeDialog">close</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: {
      minCardHeight: Number
    },
    components: {},
    data() {
      return {
        showSaveOverlay: false,
        showConfirmDelete: false,
        valid: false
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      tabName: {
        get() {
          return this.admin.selectedSubsystem &&
            this.admin.selectedSubsystem.id != 'new'
            ? `Edit Subsystem [${this.name}]`
            : 'Add New Subsystem';
        }
      },
      id: {
        get() {
          return this.admin.selectedSubsystem?.id;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'id',
            value: value
          });
        }
      },
      name: {
        get() {
          return this.admin.selectedSubsystem?.name;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'name',
            value: value
          });
        }
      },
      description: {
        get() {
          return this.admin.selectedSubsystem?.description;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'description',
            value: value
          });
        }
      },
      subsystemType: {
        get() {
          return this.admin.selectedSubsystem?.subsystemType;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'subsystemType',
            value: value
          });
        }
      },
      userType: {
        get() {
          if (
            this.admin.selectedSubsystem &&
            this.admin.selectedSubsystem.userType
          )
            return this.admin.selectedSubsystem?.userType.split(',');
          else return [];
        },
        set(value) {
          if (Array.isArray(value)) value = value.join(',');
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'userType',
            value: value
          });
        }
      },
      published: {
        get() {
          return this.admin.selectedSubsystem?.published;
        },
        set(value) {
          this.$store.commit('admin/updateEntityProperty', {
            entity: 'selectedSubsystem',
            property: 'published',
            value: value
          });
        }
      }
    },
    methods: {
      /**
       * Removes an item from the setting value.
       *
       * @param {Object} setting - The setting object.
       * @param {number} index - The index of the item to remove.
       */
      removeItem(setting, index) {
        console.log(setting.value);
        this.userType = this.userType.split(',').splice(index, 1).join(',');
        console.log(setting.value);
      },
      /**
       * Show confirm dialog
       */
      confirmDeleteSubsystem() {
        this.showConfirmDelete = true;
      },
      /**
       * Deletes the currently selected subsystem
       */
      deleteSubsystem() {
        this.$store.commit('admin/deleteSelectedSubsystem');
      },
      /**
       * Cancels upsert of a subsystem
       */
      closeDialog() {
        this.$store.commit('admin/setShowEditSubsystemDialog', false);
      },
      /**
       * Saves the subsystem currently being edited
       */
      saveSubsystem() {
        this.$store.dispatch('admin/saveSelectedSubsystem').then(() => {
          this.showSaveOverlay = true;
          // refresh subsystem list
          this.$store.dispatch(
            'admin/getSubsystemsBySystemId',
            this.admin.selectedSystem.id
          );
          setTimeout(() => {
            this.$store.commit('admin/setShowEditSubsystemDialog', false);
            this.showSaveOverlay = false;
          }, 1500);
        });
      }
    }
  };
</script>
